module.exports = __webpack_public_path__ + "img/callrail.c94c5acc.png";